import { ComingSoon } from "../RevenueShare/ComingSoon/ComingSoon";
import { Hero } from "./Hero/Hero";

export const VerifyScreens = [<Hero />];
